import { logoutProviderUser } from "../services/authApi";
import { clearDebtCustomersCache } from "../services/debtCustomersApi";
import { clearProviderCasesCache } from "../services/casesApi";
import { clearPortfolioGroupsCache } from "../services/portfolioGroupsApi";
import { clearPortfolioUploadsCache } from "../services/portfolioUploadsApi";
import { logout } from "../store/slices/authSlice";

/**
 * Clear server session (Bearer token, no body) then Redux + in-memory caches.
 */
export async function performLogout(dispatch, token) {
  await logoutProviderUser(token);
  clearDebtCustomersCache();
  clearProviderCasesCache();
  clearPortfolioGroupsCache();
  clearPortfolioUploadsCache();
  dispatch(logout());
}
